import { ConversationSidebarFilterCondition } from '../typings/conversations'

export const createConditionsArray = (sectionCondition: ConversationSidebarFilterCondition) => {
  if (Array.isArray(sectionCondition.condition)) {
    return sectionCondition.condition
  }
  return [{ ...sectionCondition }]
}

export const specifiedArraySort = <T>(arr: T[], order: string[], key: string): T[] => {
  return arr.sort((a: Record<string, any>, b: Record<string, any>) => {
    const index1 = order.indexOf(a[key])
    const index2 = order.indexOf(b[key])
    if (index1 === -1 && index2 === -1) {
      return -1
    }
    return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity)
  })
}
